var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"homepage"},[(_vm.showBadgeIdArr.indexOf(_vm.moduleId) !== -1 && _vm.showBadgeList)?[_c('div',{staticClass:"badgeBox"},[_vm._l((_vm.badgeList),function(item){return [_c('el-badge',{key:item.key,staticClass:"myBadge",attrs:{"value":item.count,"type":"success","hidden":true}},[_c('div',{on:{"click":function($event){return _vm.changeActivityName(item)}}},[_c('div',{staticClass:"badgeIcon"},[_c('div',{staticClass:"inner"},[_vm._v(" "+_vm._s(item.count)+" "),(item.key === 'instrumentVerificationRate')?_c('span',[_vm._v("%")]):_vm._e()])]),_c('div',{staticClass:"badgeText"},[_vm._v(" "+_vm._s(item.name)+" ")])])])]})],2)]:(_vm.moduleId === 27)?[_vm._m(0)]:_vm._e(),_c('el-dialog',{staticClass:"homepageDialog",attrs:{"title":"详细信息","visible":_vm.showDialog,"width":"99%","top":"10px","append-to-body":"","show-close":false},on:{"update:visible":function($event){_vm.showDialog=$event}}},[_c('span',{staticClass:"dialog-title",attrs:{"slot":"title"},slot:"title"},[_c('span',{staticStyle:{"font-weight":"bold","margin-right":"10px","font-size":"22px","vertical-align":"middle"}},[_vm._v(_vm._s(_vm.dialogTypeTitle))]),_c('el-button',{staticStyle:{"float":"right"},attrs:{"size":"mini"},on:{"click":function($event){return _vm.closeDialog()}}},[_vm._v("关闭")])],1),(_vm.showDialog)?[(_vm.dialogType == 'measuringStandard')?_c('list-v2',{attrs:{"table-height":180,"prop-query":{
            mode: 'This_Area',
            modeValue: 'CUR',
            modeType: 'Standard',
            orgId: '0',
      }}}):(_vm.dialogType == 'publicMeasurementStandards')?_c('public-list-v2',{attrs:{"table-height":180,"prop-query":{
            mode: 'This_Area',
            modeValue: 'CUR',
            orgId: '0',
      }}}):(_vm.dialogType == 'authorizedVerificationItems')?_c('cert-list-v2',{attrs:{"table-height":180,"prop-query":{
            mode: 'This_Area',
            modeValue: 'CUR',
            modeType: 'JianDing',
            orgId: '0',
      }}}):(_vm.dialogType == 'mandatoryInspectionItems')?_c('cert-list-v2',{attrs:{"table-height":180,"prop-query":{
            mode: 'This_Area',
            modeValue: 'CUR',
            modeType: 'JianDing',
            orgId: '0',
            biaozhun: '1'
      }}}):(_vm.dialogType == 'usersOfMeasuringInstruments')?_c('mechanism-list',{attrs:{"table-height":180,"prop-query":{
          organizationType: '0004'
     }}}):(_vm.dialogType == 'equipmentInUse')?_c('instrument-list',{attrs:{"table-height":180,"prop-query":{
          check: 1,
          showOnly: 1,
          region: 1,
          states: 1,
          typeName: 3
     }}}):(_vm.dialogType == 'discontinuedEquipment')?_c('instrument-list',{attrs:{"table-height":180,"prop-query":{
          check: 1,
          showOnly: 1,
          region: 1,
          states: 2,
          typeName: 3
     }}}):(_vm.dialogType == 'disableEquipment')?_c('instrument-list',{attrs:{"table-height":180,"prop-query":{
          check: 1,
          showOnly: 1,
          region: 1,
          states: 3,
          typeName: 3
     }}}):(_vm.dialogType == 'overdueUser')?_c('mechanism-list',{attrs:{"table-height":180,"prop-query":{
        organizationType: '0004',
        warnStatus: 3
     }}}):(_vm.dialogType == 'overdueInstrument')?_c('instrument-list',{attrs:{"table-height":180,"prop-query":{
          check: 1,
          showOnly: 1,
          region: 1,
          warnStatus: 3,
          typeName: 3
     }}}):(_vm.dialogType == 'calibratedMeasuringInstrument')?_c('instrument-list',{attrs:{"table-height":180,"prop-query":{
          check: 1,
          showOnly: 1,
          region: 1,
          checkResult: 1,
          typeName: 3
     }}}):(_vm.dialogType == 'instrumentVerificationRate')?_c('div',[_vm._v("强检工作计量器具检定率-暂无")]):_vm._e()]:_vm._e()],2)],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"box"},[_c('h3',{staticStyle:{"text-align":"center","color":"red"}},[_vm._v("通 告")]),_c('p',[_vm._v(" 各位用户： ")]),_c('p',{staticStyle:{"text-indent":"2em"}},[_vm._v("目前新版检务流程已开发完成并上线试运行，由于新旧流程数据不兼容，平台将采用新旧两套流程并行方式进行过渡，过渡期自2023年10月26日开始至2023年12月25日结束。新版检务流程已具备出具“燃油加油机”，“弹性元件式一般压力表和真空表”，“血压计和血压表”检定证书的检务功能，后续还将陆续推出其它强检计量器具检定证书的检务功能。")]),_c('p',{staticStyle:{"text-indent":"2em"}},[_vm._v("自过渡期开始，旧版检务流程的“新建业务”菜单关闭停止使用，使用单位提交新的器具检定申请，直接点击“强检计量器具检定”主菜单下的“新建业务”即可。过渡期期间，检定机构处理送检单位使用旧版业务流程提交的检定申请，直接点击“旧版强检器具检定”菜单处理。检定机构处理送检单位使用新版检务流程提交的申请，可直接点击“强检计量器具检定”主菜单处理，过渡期结束后，旧版检务流程功能全部关闭。")]),_c('p',{staticStyle:{"text-indent":"2em","color":"red"}},[_vm._v("请各检定机构尽快处理送检单位使用旧版业务流程提交的检定申请，确保过渡期结束日之前处理完毕")]),_c('p',{staticStyle:{"text-align":"right"}},[_vm._v("2023年10月26日")])])
}]

export { render, staticRenderFns }